/**
 * Shared money formatting for multi-currency support
 * Used by Buybox-2 and Wizard-1
 *
 * Uses a currency→locale map so the symbol displays correctly (e.g. HUF → "Ft" not "HUF").
 * Intl.NumberFormat falls back to ISO code when the locale doesn't natively use that currency.
 *
 * @param {number} amountInCurrencyUnits - Amount in main currency units (e.g. 29.99, not cents)
 * @param {string} currencyCode - ISO 4217 currency code (e.g. 'EUR', 'PLN', 'HUF')
 * @param {string|null} locale - Fallback locale when currency not in map
 * @returns {string} Formatted price string
 */
var CURRENCY_FORMAT_LOCALE = {
  EUR: 'nl-NL', PLN: 'pl-PL', HUF: 'hu-HU', GBP: 'en-GB',
  CZK: 'cs-CZ', RON: 'ro-RO', BGN: 'bg-BG', SEK: 'sv-SE', DKK: 'da-DK',
  NOK: 'nb-NO', CHF: 'de-CH', USD: 'en-US'
};

window.formatMoney = function formatMoney(amountInCurrencyUnits, currencyCode, locale) {
  const currency = (currencyCode || 'EUR').toUpperCase();
  const formatLocale = CURRENCY_FORMAT_LOCALE[currency] ||
    locale ||
    (typeof document !== 'undefined' && document.documentElement?.getAttribute?.('lang')) ||
    'nl-NL';

  let formatted = new Intl.NumberFormat(formatLocale, {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amountInCurrencyUnits);

  // Remove space between € and number for Dutch locale (matches Shopify / nl-NL)
  if ((formatLocale === 'nl' || formatLocale.startsWith('nl-')) && currency === 'EUR') {
    formatted = formatted.replace(/€\s+/g, '€');
  }

  return formatted;
};
